import axiosSmartSurvey from '../../../api/axios'

export default function useAuthentication() {

    async function fetchUserList(setUserList) {
        await axiosSmartSurvey({
            method: 'post',
            url: '/authentication/accountslist',
        }).then((response) => {
            response = response.data
            if (response.status === 'OK') {
                setUserList(response.accountsList)
            } else {
                console.log(`Error:${response.mesage}`)
            }
        })
    }
    async function changePassword(event, userId, password, confirmPassword, setSuccessAlertOpen, setSuccessText, setErrorAlertOpen, setErrorText) {
        event.preventDefault()
        const data = new FormData(event.currentTarget);
        const jsonData = {
            userId: userId,
            newPassword: data.get('newPassword'),
            confirmNewPassword: data.get('confirmNewPassword'),
        }
        await axiosSmartSurvey({
            method: 'post',
            url: '/authentication/changepassword',
            data: JSON.stringify(jsonData)
        }).then((response) => {
            if (response?.data?.status === 'OK') {
                setSuccessText(response.data.statusText)
                setSuccessAlertOpen(true)
            } else {
                setErrorText(response.data.registerError)
                setErrorAlertOpen(true)
            }
        }).catch((err) => {
            console.log(err)
        })

    }
    return { fetchUserList, changePassword }
}
